import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import apps from "../applications.json";
import "../styles/updraft.css";

const Updraft = () => {
  const [setFetchedData] = useState(null);
  const [searchParams] = useSearchParams();
  const branch = searchParams.get("branch") || "integration";

  let prefix = "_dev";
  if (branch === "integration") {
    prefix = "";
  }

  const platform = searchParams.get("platform")?.toLowerCase();
  const app = apps.find(
    (a) => a?.name?.toLowerCase() === searchParams.get("app")?.toLowerCase()
  );

  if (!app || !platform || !app.platforms.includes(platform)) {
    return <div className="updraft"><p>App not found</p></div>;
  }

  const app_name = `${app.name}_${platform}${prefix}`;
  const url =
    platform === "ios"
      ? `itms-services://?action=download-manifest&url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fifa-automation.appspot.com%2Fo%2Fplists%252F${app_name}.ipa.plist%3Falt%3Dmedia`
      : `https://firebasestorage.googleapis.com/v0/b/ifa-automation.appspot.com/o/builds%2F${app_name}.apk?alt=media`;

  useEffect(() => {
    if (platform === "ios") {
      let iOS_url = `https://firebasestorage.googleapis.com/v0/b/ifa-automation.appspot.com/o/plists%2F${app_name}.ipa.plist?alt=media`;
      fetch(iOS_url)
        .then((response) => response.json())
        .then((data) => {
          setFetchedData(data);
          console.log(data);
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);

  const img = require.context(
    "../assets/appstore",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const image = img(`./${app.imgSrc}`);
  const platformImg = require.context(
    "../assets/platforms",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const platformImage = platformImg(`./${platform}.png`);

  return (
    <div className="updraft">
      <div className="updraft__card">
        <header className="updraft__header">
          <img
            src={require("../assets/updraft.png")}
            alt="Updraft Logo"
            className="updraft__logo"
          />
        </header>

        <div className="updraft__body">
          <img src={image} alt={app.title} className="updraft__app-icon" />

          <div className="updraft__app-meta">
            {prefix === "_dev" ? <span className="updraft__dev-badge">DEV</span> : null}
            <img src={platformImage} alt="Platform" className="updraft__platform-icon" />
            <h2 className="updraft__app-title">{app.title}</h2>
          </div>

          <a href={url} className="updraft__install-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Install
          </a>
        </div>
      </div>
    </div>
  );
};

export default Updraft;
